import { SunMark } from "./Reveal";

const ITEMS = ["Good Vibes × Volleyball", "Tampa, Florida", "Summer 2027"];

const Sequence = () => (
  <span className="inline-flex items-center shrink-0">
    {ITEMS.map((item, i) => (
      <span key={i} className="inline-flex items-center">
        <span className="font-display uppercase text-2xl md:text-4xl tracking-wide px-6 md:px-8">{item}</span>
        <SunMark className="w-7 h-5 text-sun shrink-0" />
      </span>
    ))}
  </span>
);

export const Marquee = () => (
  <div className="overflow-hidden py-2">
    <div data-testid="brand-marquee" className="marquee bg-deep text-cream py-5 md:py-6 -rotate-1 scale-[1.02]">
      <div className="marquee-track">
        <Sequence />
        <Sequence />
      </div>
    </div>
  </div>
);

export default Marquee;
